'use strict';
(function () {
  var _controller = 'fileViewer.component.controller'
  angular.module('pentaApp')
    .controller(_controller, controller)
    .component('fileViewer', {
      template: '<ng-include src="templateUrl" onload="templateInit()"></ng-include>',
      controller: _controller,
      bindings: {
        // '=': Two Way Binding, lo que cambia acá, cambia en el controlador padre automáticamente
        // '<': One Way Binding (RECOMENDADO), para recibir variables, funciones, etc
        // '@': String, para recibir strings, puede ser una bandera por ejemplo
        // '&': Dinámico, se ejecuta lo que está adentro, hay que pasarle un objeto con variables 
        //      ej: componente(call-back='algo(var)')  y en el controller callBack({var: 'esto'})
        fileData: '<', // !!OBLIGATORIO, item de archivo 
        fileType: '<', // !!OBLIGATORIO, Tipo de archivo: IMG, IMAGE, FILE-IMG, VIDEO, FILE-VIDEO, AUDIO, FILE-AUDIO
        fileName: '<', // !!OBLIGATORIO si se usa imagen y audio, nombre de IMAGEN -> sirve para hacer la descarga
        resource: '<', // !!OBLIGATORIO, RECURSO DE DONDE SACAR LAS IMAGENES 
        videoSize: '<', // Objeto {width: 160, height:220} PARA CONFIGURAR TAMAÑO DE VIDEO
      }
    })

  controller.$inject = ['$scope', '$injector'];
  function controller($scope, $injector) {
    $scope.templateUrl = $scope.$root.employeeApp ? '/frontend/commons/components/fileViewer/fileViewer.component.html' : 'components/fileViewer/fileViewer.component.jade';
    var galleryPreviewModal = $scope.$root.employeeApp ? $injector.get('galleryPreview.modal') : null;

    // METHODS
    $scope.previewFile = previewFile;
    $scope.employeeApp = $scope.$root.employeeApp;

    // VARS
    var that = this;

    // WATCHERS
    $scope.$on('$destroy', onDestroy);

    /// On component init
    this.$onInit = function () {
      if (!that.resource) return console.error('Falta especificar el recurso!');
      if (!that.fileData) return console.error('No hay item que visualizar!');
      $scope.mainResource = that.resource;
      $scope.item = that.fileData;
      $scope.videoSize = that.videoSize || { width: 160, height: 220 };
      $scope.fileName = that.fileName || that.fileData.ts || ('archivo' + that.fileData._id);
      $scope.fileType = that.fileType || that.fileData.type;
    };

    function previewFile() {
      galleryPreviewModal.open({
        file: $scope.item,
        resource: $scope.mainResource
      }).then(function () { }).catch(function () { })
    }

    /////////////////////

    function onDestroy() {
      $scope.$root.abortRequests(_controller);
    }


    //// FIN CTRL
  }

})();
